'use strict';

var productBase = require('lyonscg/product/base');
var slickConfigs = require('../config/slickConfigs');
var imagesloaded = require('imagesloaded');
var zoomConfigs = require('lyonscg/config/zoomConfigs');
var utils = require('../util/utils');
var carouselsBonusProduct = require('../components/carousels');
var ada = require('../components/ada');
let isMobile = utils.isMobile();
const urlMinicartShow = $('.minicart').attr('data-action-url');

/**
 * Disable PDP Zoom
 */
function disableZoom() {
    $('.slide-link').trigger('zoom.destroy');
}

/**
 * Init PDP Zoom
 */
function initZoom() {
    disableZoom();

    var isDesktop = utils.mediaBreakpointUp('lg');
    var $activeSlide = $('.product-carousel .slick-active');

    $activeSlide.each(function () {
        var $slider = $(this);
        var $image = $slider.find('.slide-link.zoom-hires');
        var url = $image.attr('href');

        if ($image.length > 0 && url && url !== 'null' && isDesktop) {
            var config = {
                url: url
            };
            config = $.extend({}, zoomConfigs, config);
            $image.zoom(config);
        }
    });
}


/**
 * If the current slide has a data-caption attribute, render the value within caption-container class element. Otherwise, render an empty string.
 * @param {jquery} $carousel - the carousel to update a caption on
 * @param {number} nextSlideIndex - the slick slider index of the next slide
 */
function updateCaptionText($carousel, nextSlideIndex) {
    var $activeImage;
    var $caption = $carousel.parent().find('.caption-container .caption-text');

    if ($caption.length === 0) return;

    if (typeof (nextSlideIndex) !== 'undefined') {
        $activeImage = $carousel.find(`[data-slick-index="${nextSlideIndex}"] .slide-img`);
    } else {
        $activeImage = $carousel.find('.slick-active .slide-img');
    }

    var captionText = $activeImage && $activeImage.attr('data-caption') ? $activeImage.attr('data-caption') : '';
    $caption.text(captionText);

    // If slick dots are visible, move caption to be before the dots
    if ($carousel.find('.slick-dots').length > 0 && $carousel.find('.caption-container').length === 0) {
        $carousel.find('.slick-dots').before($('.caption-container').last());
    }
}

/**
 * Init the product video in modal
 */
function videoInModalInit() {
    $(document).on('ready', function () {
        window.oneTrustUtil = window.oneTrustUtil || [];
        window.oneTrustUtil.push(function () {
            window.sYoutubeHost = 'www.youtube-nocookie.com';
            if (oneTrustUtil.allowTargeting()) { // eslint-disable-line
                window.sYoutubeHost = 'www.youtube.com';
                var $ytContent = $('.youtube-content');
                if ($ytContent) {
                    var srcURL = $ytContent.attr('src');
                    if (srcURL.indexOf('www.youtube-nocookie.com') !== -1) {
                        srcURL = srcURL.replace('www.youtube-nocookie.com', 'www.youtube.com');
                        $ytContent.attr('src', srcURL);
                    }
                }
            }
        });
    });

    $('body').on('click', '.pdp-video-link', (e) => {
        const $btn = $(e.currentTarget);
        const ytHost = window.sYoutubeHost ? window.sYoutubeHost : 'www.youtube-nocookie.com';
        // Traverse DOM based if PDP Video is a Feature Video or a Product Video Caro
        const $modal = $btn.hasClass('feature-video-link') ? $btn.parents('.feature-video').next('.product-video-modal') : $btn.parents('.video-wrapper').children('.product-video-modal');

        const $video = $modal.find('iframe');
        const $ytID = $modal.data('id');
        const $ytURL = 'https://' + ytHost + '/embed/' + $ytID + '?rel=0feature=oembed';

        $modal.on('shown.bs.modal', function () {
            $video.attr('src', $ytURL);
        });

        $modal.on('hidden.bs.modal', function () {
            $video.attr('src', '');
        });
    });
}

/**
 * Init the product carousel using a predefined slick configuration
 */
function carouselInit() {
    // eslint-disable-next-line no-param-reassign
    var $productContainer = $('.product-detail');

    var $carousels = $productContainer.find('.product-carousel');
    var $carouselsSmall = $productContainer.find('.product-small-carousel');

    if ($carousels.length) {
        $carousels.each(function () {
            var $carousel = $(this);
            var $wrapper = $carousel.closest('.product-detail');
            if ($wrapper.hasClass('product-detail-bundle')) {
                $wrapper = $wrapper.find('.product-detail-bundle-wrapper');
            }

            $carousel.not('.slick-initialized').slick(slickConfigs.pdp);
            initZoom();

            $carousel.on('afterChange', initZoom.bind($wrapper));
            $carousel.on('init', function () {
                ada.accessbileSliders($carousel);
                initZoom();
                updateCaptionText($carousel);
            }).on('afterChange', function () {
                ada.accessbileSliders($carousel);
                initZoom();
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                updateCaptionText($carousel, nextSlide);
            });
            $carousel.not('.slick-initialized').slick(slickConfigs.pdp);
        });
    }

    if ($carouselsSmall.length) {
        $carouselsSmall.each(function () {
            var $carousel = $(this);

            // Get previous product caro ID for slick asNavFor
            var prodCaroID = '#' + $carousel.siblings('.product-carousel').attr('id');

            // Get unique thumbnail slides to add aria-labels for ADA, exclude cloned slides
            var $prodCaroThumbUnique = $carousel.find('.slick-slide:not(.slick-cloned) .slide img');

            // Match unique slides to cloned slides by shared alt attributes. Set aria-labels that differentiate unique slides from cloned slides.
            if ($prodCaroThumbUnique.length > 0) {
                $prodCaroThumbUnique.each(function (index) {
                    $(this).parent().attr('aria-label', 'Carousel slide image ' + (index + 1) + ' of ' + $prodCaroThumbUnique.length);
                    var thumbnailLabel = $(this).parent().attr('aria-label');
                    var thumbnailAlt = $(this).attr('alt');
                    $('.product-small-carousel .slick-cloned .slide [alt="' + thumbnailAlt + '"]').parent().attr('aria-label', 'Clone of ' + thumbnailLabel);
                });
            }
            // Init slick caro for product thumbnails on PDP
            $carousel.not('.slick-initialized').on('init', function () {
                ada.accessbileSliders($carousel);
            }).on('afterChange', function () {
                ada.accessbileSliders($carousel);
            }).slick({
                vertical: true,
                infinite: true,
                accessibility: false,
                speed: 400,
                lazyLoad: 'ondemand',
                dots: false,
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                focusOnSelect: true,
                asNavFor: prodCaroID,
                responsive: [{
                    breakpoint: utils.getViewports('lg'),
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                }]
            });
        });
    }
}


/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else if ($('.storepage').length) {
        // page designer detail tile component
        pid = $($el).closest('.pd-product-detail').data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    let $selector = $('.quantity-select');
    if ($el && ($('.set-items').length || $('.storepage').length)) {
        $selector = $($el).closest('.product-detail').find('.quantity-select');
    }
    return $selector;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    // Overrides Base Bonus Product Modal
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    // Overrides Base Bonus Product Modal
    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');

            $('.bonus-product-item').each(function () {
                var bonusItem = $(this);
                imagesloaded(bonusItem).on('done', function () {
                    carouselsBonusProduct.quickviewCarousel();
                });
            });

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Scroll to active accordion header with class scollTo
 */
function scrollToActiveAccordion() {
    $('html, body').animate({
        scrollTop: $('.scrollTo').offset().top
    }, 2000);
}

/**
 * Show add to cart message
 * @param {string} response - ajax response from clicking the add to cart button
 */
function showAddToCartToast(response) {
    // show add to cart toast
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    if ($('.add-to-cart-messages').length === 0) {
        $('body').append(
            '<div class="add-to-cart-messages"></div>'
        );
    }

    $('.add-to-cart-messages').append(
        '<div class="add-to-basket-alert alert ' + messageType + ' alert-dismissible fade show" role="alert">'
        + response.message
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span></button>'
        + '</div>'
    );

    // set tabindex and focus
    $('.add-to-basket-alert').attr('tabindex', 0);
    $('.add-to-basket-alert').focus();

    $('.add-to-basket-alert').on('closed.bs.alert', function () {
        $('.add-to-cart-messages').remove();
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);

    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (response.recommendationInterceptData && Object.keys(response.recommendationInterceptData).length !== 0) {
        var recommendationIntercept = require('../cart/recommendationIntercept');
        var promise = recommendationIntercept.methods.showRecommendationIntercept(response.recommendationInterceptData);
        promise.fail(function (data) {
            showAddToCartToast(response);
            if (data && data.redirectUrl) {
                location.href = data.redirectUrl;
            }
        });
    } else {
        // A/B TEST minicart-redesign: SKIP DISPLAYING THE TOAST (EXCEPT /cart PAGE)
        if (response.minicartVariantA && window.pageContext.title !== 'Cart') return;
        if (!isMobile) { // eslint-disable-line no-lonely-if
            showAddToCartToast(response);
        }
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @param {jQuery} $addToCartButton - DOM element for add to cart button
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts($addToCartButton) {
    var childProducts = [];
    $addToCartButton.closest('.product-detail, .tile-add-to-cart').find('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').first().text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * For Checkbox promotion, add after product has been added to cart
 *
 * @param {jQuery} $container - DOM element for parent
 */
function checkForCoupon($container) {
    var $safeContainer = $container || $(document);
    var checkbox = $safeContainer.find('#checkboxPromotion');
    var useCheckbox = checkbox ? checkbox.is(':checked') : false;

    if (checkbox && useCheckbox) {
        var url = $safeContainer.find('#checkbox-coupon-form').attr('action');
        var checkboxform = $safeContainer.find('#checkbox-coupon-form').serialize();
        var $couponLabel = $safeContainer.find('.callout-badge');
        $.ajax({
            url: url,
            method: 'GET',
            data: checkboxform,
            success: function () {
                $safeContainer.find('.checkboxPromotion').hide();
                $couponLabel.html($couponLabel.data('applied-title'));
            }
        });
    }
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Dynamically creates Slick.js carousel from response containing images. Overrides the default storefront Bootstrap carousel.
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var carousel = $productContainer.find('.product-carousel');
    var smallCarousel = $productContainer.find('.product-small-carousel');
    var accessibleZoomCarousel = $productContainer.find('.zoom-feature-img');
    var accessibleZoomThumbnails = $productContainer.find('.zoom-tile-nav');

    // REMOVE SLIDES FROM SLICK.JS PRODUCT CAROUSELS (LARGE, SMALL, AND ACCESSIBLE ZOOM), REMOVE ACCESSIBLE ZOOM NAV THUMBNAILS
    var largeCarouselSlideCount = $('.product-carousel').slick('getSlick').$slides;
    var smallCarouselSlideCount = $('.product-small-carousel').slick('getSlick').$slides;

    accessibleZoomCarousel.removeClass('slick-initialized').children().remove();
    accessibleZoomThumbnails.children().remove();

    for (let i = 0; i < largeCarouselSlideCount.length; i++) {
        $(carousel).slick('slickRemove', [0]);
    }
    for (let j = 0; j < smallCarouselSlideCount.length; j++) {
        $(smallCarousel).slick('slickRemove', [0]);
    }
    // REPLACE CAROUSEL SLIDES AND ACCESSIBLE ZOOM NAV THUMBNAILS W/ PARAM imgs
    for (let k = 0; k < imgs.length; k++) {
        $(carousel).slick('slickAdd', '<div><div><div class="slide slide-link justify-content-center zoom-hires" href="' + imgs[k].url.split('?')[0] + '?sw=1000&sh=1000&sm=fit" ><img class="img-fluid slide-img" src="' + imgs[k].url + '" alt="' + imgs[k].alt + ' image number ' + [k] + '"  title="' + imgs[k].title + '" /></div></div></div>');
        $(accessibleZoomCarousel).append('<div class="slide slide-link justify-content-center" ><img class="mx-auto" src="' + imgs[k].url.split('?')[0] + '?sw=1000&sh=1000&sm=fit" alt="Expanded View ' + imgs[k].alt + '"  title="' + imgs[k].title + '" /></div>');
        $(smallCarousel).slick('slickAdd', '<div><button type="button" class="slide" style="width: 100%; display: inline-block;" aria-label="Clone of Carousel slide image"' + imgs[k] + ' of ' + imgs.length + '"><img src="' + imgs[k].url + '" data-src="' + imgs[k].url + '" class="slide-img" alt="' + imgs[k].alt + ' image number ' + [k] + '"></button></div>');
        accessibleZoomThumbnails.append('<img src="' + imgs[k].url + '" data-src="' + imgs[k].url + '" class="enlarged-img-thumbnail mb-2" alt="Thumbnail view ' + imgs[k].alt + '" data-step="' + [k] + '" aria-description="Click the image for an expanded view" />');
    }
    initZoom();
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} options - Ajax response options from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(options, $productContainer) {
    options.forEach(function (option) {
        var $optionEl = $productContainer.find('.product-option[data-option-id*="' + option.id
            + '"]');
        option.values.forEach(function (value) {
            var valueEl = $optionEl.find('option[data-value-id*="' + value.id + '"]');
            valueEl.val(value.url);
        });
    });
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for promotions section
 *
 * @param {array} promotions - list of promotions
 * @return {string} - Compiled HTML
 */
function getPromotionsHtml(promotions) {
    if (!promotions) {
        return '';
    }

    var html = '';

    promotions.forEach(function (promotion) {
        html += '<div class="callout" title="' + promotion.details + '">' + promotion.calloutMsg +
            '</div>';
    });

    return html;
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $('.promotions').empty().html(getPromotionsHtml(response.product.promotions));

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.options, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
    initZoom();
}

$('body').on('hidden.bs.modal', '#recommendationInterceptModal', function () {
    location.reload();
});

var exportBase = $.extend({}, productBase, {
    carouselInit: carouselInit,
    videoInModalInit: videoInModalInit,
    scrollToActiveAccordion: scrollToActiveAccordion,

    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($(this).parents('.choice-of-bonus-product').find('.bonus-quantity-select').val(), 10) || 1;
            if (isNaN(submittedQty)) {
                submittedQty = 1;
            }
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $(this).parents('.choice-of-bonus-product').find('.product-option').data('option-id');
            var valueId = $(this).parents('.choice-of-bonus-product').find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-9 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var quantity;
            var pdRedirectUrl;

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            if ($(this).hasClass('add-to-cart-tile')) {
                pid = $(this).data('pid');
                addToCartUrl = $(this).data('add-to-cart-url');
                quantity = 1;
            } else {
                pid = getPidValue($(this));
                addToCartUrl = getAddToCartUrl();
                quantity = getQuantitySelected($(this));
            }
            // page designer component redirect to cart configuration
            pdRedirectUrl = $(this).data('redirect-url') || null;

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts($(this)),
                quantity: quantity
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            var $atc = $(this);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);

                        data.redirectUrl = pdRedirectUrl;
                        $('body').trigger('product:afterAddToCart', data);

                        var isProductTile = $atc.closest('.product-tile').length > 0;
                        var parent = null;
                        if (isProductTile) {
                            parent = $atc.closest('.product-tile');
                            checkForCoupon($(parent));
                        } else {
                            checkForCoupon();
                        }

                        $.spinner().stop();
                        // page designer component configuration to redirect to cart
                        if (pdRedirectUrl && !data.pliUUID) {
                            window.location = pdRedirectUrl;
                        }
                        if ($atc.parents().find('#recommendationInterceptModal').length > 0) {
                            $('#maincontent').load(location.href + ' #maincontent');
                        }
                        if (!(data.action === 'Cart-Show')) {
                            // A/B TEST minicart-redesign: ON ADD TO CART FROM /cart PAGE, RELOAD THE PAGE INSTEAD OF TRIGGERING MINICART.
                            if (data.minicartVariantA && window.pageContext.title === 'Cart') {
                                location.reload();
                                return;
                            }
                            $('.minicart').trigger('click', data);
                            $('.minicart .popover').addClass('show');
                        }
                    },
                    error: function (data) {
                        showAddToCartToast(data.responseJSON);
                        $.spinner().stop();
                    },
                    complete: function (data) {
                        // A/B TEST minicart-redesign: HANDLE ADD TO CART FROM PRODUCT RECOMMENDATIONS INSIDE MINICART -> REFRESH MINICART DATA
                        if ($atc.parents('.minicart-recommendations').length > 0 && data.responseJSON.minicartVariantA) {
                            $('.minicart .popover').empty();
                            $('.minicart .popover').spinner().start();
                            $.get(urlMinicartShow, function (minicartData) {
                                $('.minicart .popover').append(minicartData);
                                $('.minicart .popover').spinner().stop();
                            });
                            return;
                        }

                        $('html, body').animate({
                            scrollTop: !isMobile ? $('body').offset().top : scrollY
                        }, 500);
                    }
                });
            }
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },
    updateCaptionText: updateCaptionText
});

module.exports = exportBase;
